// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"Loading__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Loading/Loading.scss
 ** module id = 922
 ** module chunks = 1
 **/